import { faLaptopMobile, faDesktop, faTabletScreen } from "@fortawesome/pro-light-svg-icons"

import { ChannelCardConfig } from "../../../merchant/admin/messages/components/MessageChannelCard"
import { MessageAdditionalDataChannelsType } from "./serviceCenterMessagesTypes"

export const SERVICE_CENTER_CHANNEL_OPTIONS: ChannelCardConfig[] = [
    {
        type: MessageAdditionalDataChannelsType.IN_APP,
        icon: faLaptopMobile,
    },
    {
        type: MessageAdditionalDataChannelsType.INFO_DISPLAYS,
        icon: faDesktop,
    },
    {
        type: MessageAdditionalDataChannelsType.ROOM_DISPLAYS,
        icon: faTabletScreen,
    },
]
